import store from '@/store'

export default [
  {
    path: '/stock-ins',
    name: 'stock-in',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-in/index.vue')
  },
  {
    path: '/stock-ins/create',
    name: 'stock-in-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-in/create.vue')
  },
  {
    path: '/stock-ins/:id',
    name: 'stock-in-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-in/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stockIn/find', to.params.id)
      next()
    }
  }
]
